import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import copyIcon from '@/assets/icons/copy-icn.svg';
import bg from '@/assets/pages/error/bg.webp';
import { toastManager } from '@/store';

import { Button } from '../Button';
import { PageLayout } from '../PageLayout';
import styles from './Error.module.scss';

type ErrorProps = {
  hasError: boolean;
  message?: string;
};

export const Error = observer<ErrorProps>(({ hasError, message = '' }) => {
  const { t } = useTranslation();

  const copy = useCallback(() => {
    navigator.clipboard.writeText(message).then(() => {
      toastManager.success(t('pages.error.copy'), copyIcon);
    });
  }, [message, t]);

  useEffect(() => {
    if (hasError) return;

    window.location.href = window.location.origin;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageLayout className={clsx('in-col-center', styles.error)}>
      <img src={bg} alt="warning icon" width="196" />
      <h1 className="in-text-h1">{t('pages.error.title')}</h1>
      <section className="in-section">
        <span className="in-text-16 in-text-center">
          {t('pages.error.message')}
        </span>
      </section>
      <section
        className="in-row-center in-text-16"
        style={{ position: 'relative', width: '100%' }}
      >
        <span className={styles.message}>{message}</span>{' '}
        <i className={styles.copy} onClick={copy} />
      </section>
      <section className="in-section">
        <Button
          onClick={() => {
            window.location.href = window.location.origin;
          }}
        >
          {t('pages.error.action')}
        </Button>
      </section>
    </PageLayout>
  );
});
